import { axios } from '@/utils/request'

/**
 * 获取计量单位
 * @param parameter
 * @returns {*}
 */
export function getUnitList (parameter) {
  return axios({
    url: '/unit/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 修改计量单位
 * @param parameter
 * @returns {*}
 */
export function editUnit (parameter) {
  return axios({
    url: '/unit/edit/' + parameter.id,
    method: 'post',
    data: parameter
  })
}

/**
 * 新增计量单位
 * @param parameter
 * @returns {*}
 */
export function addUnit (parameter) {
  return axios({
    url: '/unit/add',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除计量单位
 * @param parameter
 * @returns {*}
 */
export function deleteUnit (parameter) {
  return axios({
    url: '/unit/delete',
    method: 'post',
    data: parameter
  })
}
